import ICON_LIKE_LIGHT from '../../../public/static/v4/like/icon-like-light.svg';
import ICON_LIKE_LIGHT_OFF from '../../../public/static/v4/like/icon-like-off-light.svg';
import ICON_LIKE_OFF from '../../../public/static/v4/like/icon-like-off.svg';
import ICON_LIKE from '../../../public/static/v4/like/icon-like.svg';
import Anchor from '../../common/component/Anchor';
import Button from '../../common/component/Button';
import EllipsisText from '../../common/component/EllipsisText';
import SingleText from '../../common/component/SingleText';
import useTheme from '../../common/hook/useTheme';

interface IProps {
  isLike: boolean;
  isOnlyDarkMode?: boolean;
  description?: string;
  keywords?: string[];
  className?: string;
  descClassName?: string;
  onClickLike?: (isLike: boolean) => void;
  onClickKeyword?: (keyword: string) => void;
}

export default function ContentLikeV4({
  isLike,
  isOnlyDarkMode,
  description,
  keywords,
  className,
  descClassName,
  onClickLike,
  onClickKeyword,
}: IProps) {
  const {theme} = useTheme();
  const iconMap = ICON_LIKE_MAP[isOnlyDarkMode ? 'dark' : theme];
  return (
    <div className={cn('flex flex-col gap-y-10', className)}>
      <div className="flex items-start justify-between">
        {description && (
          <EllipsisText
            line={2}
            className={cn(
              's13-regular-white leading-18',
              !isOnlyDarkMode && 'light:text-black',
              descClassName
            )}
            data-testid="description"
          >
            {description}
          </EllipsisText>
        )}
        <Button
          className="-mt-2"
          onClick={() => onClickLike?.(!isLike)}
          data-testid="like-button"
        >
          <img
            src={isLike ? iconMap.on : iconMap.off}
            className="w-24 h-24"
            alt="like"
          />
        </Button>
      </div>
      {keywords && (
        <div className="flex items-center gap-x-4">
          {keywords.map((keyword, index) => (
            <Anchor
              key={index}
              display="flex"
              className={cn(
                'flex-center h-20 px-6 rounded-5 overflow-hidden first:overflow-visible',
                's12-regular-white',
                'bg-white/15',
                !isOnlyDarkMode && 'light:text-black light:bg-black/10'
              )}
              onClick={() => onClickKeyword?.(keyword)}
            >
              <SingleText width="auto">{keyword}</SingleText>
            </Anchor>
          ))}
        </div>
      )}
    </div>
  );
}

const ICON_LIKE_MAP = {
  dark: {
    on: ICON_LIKE,
    off: ICON_LIKE_OFF,
  },
  light: {
    on: ICON_LIKE_LIGHT,
    off: ICON_LIKE_LIGHT_OFF,
  },
};
